import { FileUploadInfo, IDataLoadService } from '@price-for-profit/micro-services';
import { CLIENT_ID, USER_GUIDE_PDF } from 'shared/constants/app';

export interface DownloadPdfProps {
  fileId: string;
}

export interface IPdfUploadService {
  uploadPdfFile(files: FormData): Promise<FileUploadInfo[]>;
  downloadPdfFile(props: DownloadPdfProps): Promise<void>;
}

export class PdfUploadService implements IPdfUploadService {
  constructor(private dataloadService: IDataLoadService) {}

  async uploadPdfFile(files: FormData): Promise<FileUploadInfo[]> {
    let file;

    try {
      file = await this.dataloadService.getFile({
        clientId: CLIENT_ID,
        fileName: USER_GUIDE_PDF,
      });
    } catch {}

    if (file) {
      await this.dataloadService.deleteFile({
        clientId: CLIENT_ID,
        fileName: USER_GUIDE_PDF,
      });
    }

    return await this.dataloadService.uploadFile({
      clientId: CLIENT_ID,
      files,
    });
  }

  async downloadPdfFile(props: DownloadPdfProps): Promise<void> {
    const file = await this.dataloadService.getFile({
      clientId: CLIENT_ID,
      fileName: props.fileId,
    });

    this.handleBlob(file, props.fileId);
  }

  private handleBlob(blob: Blob, fileName: string) {
    const blobUrl = URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href);
    link.parentNode?.removeChild(link);
  }
}
